// Module
var code = "<!--Custom cursor for lightoxable images -->\n<div class=\"follower\">\n\t<span class=\"line line__horizontal\"></span>\n\t<span class=\"line line__vertical\"></span>\n</div>\n";
// Exports
export default code;